import { cn } from '@/utils';
import { type HeroCardData } from '../../types';
import { CategoryChips } from './CategoryChips';
import { HeroMetadata } from './HeroMetadata';
import { HeroTitle } from './HeroTitle';
type HeroContentProps = {
  data: HeroCardData;
  className?: string;
};
export const HeroContent = ({
  data,
  className
}: HeroContentProps) => {
  return <div className={cn('flex min-w-0 flex-1 flex-col', 'tablet-sm:gap-sm gap-xs', className)} data-sentry-component="HeroContent" data-sentry-source-file="HeroContent.tsx">
      <div className={cn('flex w-full flex-col', 'tablet-sm:gap-[14px] gap-xs')}>
        <CategoryChips category={data.category} data-sentry-element="CategoryChips" data-sentry-source-file="HeroContent.tsx" />
        <HeroTitle title={data.title} data-sentry-element="HeroTitle" data-sentry-source-file="HeroContent.tsx" />
      </div>

      <HeroMetadata data={data} data-sentry-element="HeroMetadata" data-sentry-source-file="HeroContent.tsx" />
    </div>;
};